module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkIn weight"
  }, [_c('mu-row', {
    staticClass: "content",
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticStyle: {
      "padding-right": "24px"
    },
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('div', {
    staticClass: "bigTxt first"
  }, [_vm._v("HbA1c readings are a great way to mark your progress.")]), _vm._v(" "), _c('div', {
    staticClass: "bigTxt"
  }, [_vm._v("What was your last HbA1c result?")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_c('mu-card', {
    staticStyle: {
      "width": "280px",
      "margin": "0 auto"
    }
  }, [_c('mu-card-text', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "lgTxt"
  }, [_vm._v("My HbA1c is...")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.$store.state.user.settings.hba1c.measure === 'percentage') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.percent),
      expression: "model.percent",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "min": "0",
      "type": "number",
      "data-vv-validate-on": "none",
      "data-vv-rules": 'min_value:0|max_value:25',
      "data-vv-name": "hba1c_percent",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit
    },
    domProps: {
      "value": (_vm.model.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "percent", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  Percent (%)\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.hba1c.measure === 'mmol-mol') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "shadow"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.model.mmol_mol),
      expression: "model.mmol_mol",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "min": "0",
      "type": "number",
      "data-vv-rules": 'min_value:0|max_value:300',
      "data-vv-name": "hba1c_mmol_mol",
      "data-vv-as": _vm.$store.state.user.settings.hba1c.unit
    },
    domProps: {
      "value": (_vm.model.mmol_mol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "mmol_mol", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n                  mmol/mol\n                ")])]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "disabled": _vm.isProcessing,
      "type": "button",
      "label": !_vm.isProcessing ? _vm.$t('message.nextText') : _vm.$t('message.savingText'),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-738d179f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CheckIn/Hba1c.vue
// module id = 3226
// module chunks = 1